import { StripeLogo } from '@phosphor-icons/react';

export default StripeLogo;